export default "__VITE_ASSET__B4NtE0Jf__"